const { cloneDeep } = require('lodash');

const settingDefaults = Object.freeze({
    // Please keep the settings in alphabetical order
    checkoutConfirmation: {
        deliveryMethodMessagePickup: 'Your order can be collected from',
        deliveryMethodMessageDeliver: 'Your order will be delivered',
    },

    delivery: {
        deliveryWindowReloadingMessage: 'Refreshing products and pricing for your new delivery time and location.',
    },

    deliveryWindowAlerts: {
        alertTitle: 'Delivery Window Alert',
        expressDeliveryUnavailableMessage: 'Sorry, Express Delivery is no longer available at this current time. Choose another delivery method or pickup.',
        orderLimitExceededWarningError: 'Your cart has exceeded the limit for Express Delivery',
    },

    footer: {
        customerServiceLinks: [
            ['Customer Service'],
            ['Product Safety', '/shop/discover/about-us/product-safety'],
            ['Product Recalls', '/shop/discover/about-us/product-recalls'],
            ['Scam Warning', '/shop/discover/about-us/scam-alert'],
            ['Help & Support', '/shop/page/help-and-support-faq'],
            ['Feedback', '/shop/page/help-and-support-faq'],
            ['Contact Us', '/shop/discover/about-us/contact-us'],
            ['Return Policy', '/shop/discover/about-us/returns-policy'],
            ['Offers & Competitions', '/shop/discover/about-us/offers-and-competitions'],
            ['Accessibility', '/shop/support/accessibility'],
        ],
        generalServiceLinks: [
            ['Services'],
            ['Delivery', '/shop/discover/shopping-online/delivery'],
            ['Click & Collect', '/shop/discover/shopping-online/click-collect'],
            ['New to our Store?', '/shop/discover/shopping-online/new-to-online'],
            ['My Business', '/shop/discover/shopping-online/my-business'],
            ['Community Donations', '/shop/discover/community-donations'],
        ],
        toolsLinks: [
            ['Tools'],
            ['Delivery Saver', '/shop/discover/shopping-online/delivery-saver'],
            ['Track My Order', '/shop/trackmyorder'],
            ['Woolworths Apps', '/shop/discover/about-us/woolworths-app'],
            ['Vendors', 'http://www.wowlink.com.au/wps/portal'],
            ['Woolworths Flowers', 'http://www.woolworthsflowers.com.au/home.aspx'],
            ['WOW Careers', 'http://www.wowcareers.com.au/'],
        ],
        aboutUsLinks: [
            ['About Us'],
            ['Our Stores', '/shop/storelocator'],
            ['Our Brands', '/shop/discover/our-brands'],
            ['Affiliates', '/shop/discover/about-us/partner-program'],
            ['Clubs'],
            ['Woolworths Rewards', 'https://www.woolworthsrewards.com.au/'],
            ['Baby and Toddler Club', 'https://woolworthsbabyandtoddlerclub.com.au/'],
        ],
    },

    fulfilmentMethod: {
        pickupOptionName: 'Pick Up',
        deliveryOptionName: 'Delivery',
        pickupOptionMessage: 'to collect my groceries',
        deliveryOptionMessage: 'my groceries delivered',
        noneOptionMessage: 'to choose later',
        questionnaireHeading: 'Delivery or Collection?',
        timetablePickupName: 'pickup',
    },

    fulfilmentTimetable: {
        noAvailableTimesMessage: 'Unfortunately we do not deliver to this area yet. Please try another address or change your delivery to pick up.',
    },

    lists: {
        myWoolworthsRewardsListPageHeading: 'Products I Purchased with my Woolworths Rewards Card',
    },

    orderConfirmation: {
        pickupMessage: 'Your order can be collected from',
        deliveryMessage: 'Your order will be delivered to',
    },

    orderManagement: {
        editDeliveryInfoPickUp: 'to collect my groceries from',
        editDeliveryInfoDelivery: 'my groceries delivered to',
        itemPickupFrom: 'Collect From:',
        itemHubSpok: 'Collect From:',
    },

    productRestrictions: {
        productTileRestrictionPmDelivery: 'Available for afternoon delivery and pick up orders',
        productTileRestrictionPickUpOnly: 'Available for pick up orders only',
        productTileRestrictionDeliveryOnly: 'Available for delivery orders only',
    },

    productDetailsAdditionalAttributes: {
        productDetailsHealthStarRatingPath: 'https://wowuatmediaaae.blob.core.windows.net/content/hsricons/',
    },

    signUpForm: {
        pickupTitle: 'Click & Collect',
        pickupDescription: 'Collect your groceries from a local store for FREE',
    },

    search: {
        searchSuggestionThrottleTimeout: 500,
    },
});

const settings = cloneDeep(settingDefaults);

module.exports = {
    settings,
    settingDefaults,
};



// WEBPACK FOOTER //
// ./src/common/settings/settings.constants.js